import type { ReactNode } from 'react';
import React from 'react';
import { FAQList } from '../../../../../common/display/faqTab/faqList/FAQList';

import type { messages } from '../../../../../../i18n/messages';
import { CustomerService } from './CustomerService';

const styles = {
  FAQSection: { maxWidth: 530 },
};

type FAQSectionProps = {
  benefit: keyof (typeof messages)['de-DE']['benefits'];
  values?: Record<string, ReactNode>;
};

const FAQTab = ({ benefit, values }: FAQSectionProps) => {
  return (
    <div style={styles.FAQSection}>
      <FAQList benefit={benefit} values={values} />
      <CustomerService />
    </div>
  );
};

export default FAQTab;
